module.exports = "/_next/static/images/cabcd9c55dbdffeebadd03212ee3e423-man-with-cellphone-md@1x.jpg";